import styles from './skeleton.module.scss';
import MaterialSkeleton from '@mui/material/Skeleton';

/* eslint-disable-next-line */
export interface SkeletonProps {
  animation?: 'pulse' | 'wave' | false,
  children?: any,
  // classes?: object,
  // component?: any,
  height?: number | string,
  // sx?: any,
  variant?: 'circular' | 'rectangular' | 'text'
  width?: number | string,
  className?: string,
  ['data-testid']?: string
}

export function Skeleton(props: SkeletonProps) {
  return (
    <MaterialSkeleton
      variant={props.variant}
      width={props.width}
      height={props.height}
      animation={props.animation}
      className={props.className}
      data-testid={props['data-testid']}>
      {props.children}
    </MaterialSkeleton>
  );
}

export default Skeleton;